import { render, staticRenderFns } from "./RubroCreateUpdate.vue?vue&type=template&id=8c2ab476&scoped=true&"
import script from "./RubroCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./RubroCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RubroCreateUpdate.vue?vue&type=style&index=0&id=8c2ab476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2ab476",
  null
  
)

export default component.exports